import { Flex } from '@chakra-ui/react';
import { CircularProgress } from 'library/atoms';
import { useEffect } from 'react';
import { OnCallUsersPerHourData } from 'views/main/organization/analytics-v3/api/types';
import { useAnalyticsTable } from 'views/main/organization/analytics-v3/hooks/useAnalyticsTable';
import { useGetOnCallHourPerUserData } from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import AnalyticsTable from '../../../Table/AnalyticsTable';
import { DashboardContainer } from './style';
import { useOnCallHourContext } from 'views/main/organization/analytics-v3/hooks/useOnCallHourContext';
import { useShallow } from 'zustand/react/shallow';
import { PaginationType } from 'views/main/organization/analytics-v3/hooks/types';
import React from 'react';
import TopCard from '../TopCard';
import { AppTracker } from 'shared/analytics/tracker';
import { ANALYTIC_V3_EVENTS } from 'views/main/organization/analytics-v3/constants';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { IAppState } from 'core/interfaces/IAppState';

function OnCallUsers() {
  const { OnCallUsersPerHourColumns } = useAnalyticsTable();
  const queryClient = useQueryClient();
  const teamID = useSelector((state: IAppState) => state.organization.selectedTeam.teamId);

  const { data, isLoading } = useGetOnCallHourPerUserData();

  useEffect(() => {
    queryClient.invalidateQueries('onCallHour-perUser');
  }, [teamID]);
  const onCallHoursData = useOnCallHourContext(useShallow(state => state.onCallUserPerHourData));

  const onCallTablePaginationInfo = useOnCallHourContext(
    useShallow(state => state.onCallUserPerHourTablePaginationInfo),
  );

  const setPagination = useOnCallHourContext(state => state.setOnCallUserPerHourPagination);

  const handlePaginationChange = (page: Partial<PaginationType>) => {
    setPagination(page);
  };

  useEffect(() => {
    AppTracker.track(ANALYTIC_V3_EVENTS.INCIDENT_ANALYTICS_PAGE_VIEWED, {
      'Analytics Scope': 'Team Analytics',
      'Analytics Type': 'On-Call Analytics',
      'Analytics Tab': 'On-Call Analytics',
    });
  }, []);

  return (
    <React.Fragment>
      <TopCard />
      <DashboardContainer>
        {isLoading ||
        (onCallHoursData?.data?.onCallHours !== null &&
          onCallHoursData?.data?.onCallHours?.length === 0) ? (
          <Flex justifyContent={'center'} alignItems={'center'} m={3} height={'70vh'}>
            <CircularProgress isIndeterminate />
          </Flex>
        ) : (
          <AnalyticsTable<OnCallUsersPerHourData>
            columns={OnCallUsersPerHourColumns}
            data={onCallHoursData.data.onCallHours || []}
            pageCount={onCallHoursData?.data.totalCount ?? 0}
            pageIndex={onCallTablePaginationInfo.pageIndex}
            pageSize={onCallTablePaginationInfo.pageSize}
            onPaginationChange={handlePaginationChange}
            key={'defaultKey'}
            onSortChange={() => {}}
            isLoading={
              isLoading ||
              (onCallHoursData?.data?.onCallHours !== null &&
                onCallHoursData?.data?.onCallHours?.length === 0)
            }
            sorting={onCallTablePaginationInfo.sortBy}
            maxPageSize={10}
          />
        )}
      </DashboardContainer>
    </React.Fragment>
  );
}

export default OnCallUsers;
